import { App } from "antd";
import { useCallback } from "react";

import type { Notifications } from "./types";

/**
 * NotificationHelper knows four levels; antd's message API calls the neutral
 * one "info".
 */
const ANTD_LEVEL = {
  error: "error",
  warning: "warning",
  notice: "info",
  success: "success",
} as const;

/**
 * Shows what the server said. The API already answers in the user's language
 * and phrases every outcome itself, so a screen must not invent its own text
 * for a write it just performed — it only decides *where* the text appears.
 */
export function useServerNotifications() {
  const { message } = App.useApp();

  return useCallback(
    (notifications: Notifications | null | undefined) => {
      notifications?.messages?.forEach((entry) => {
        const level = ANTD_LEVEL[entry.notification_type] ?? "info";
        void message[level](entry.notification_value);
      });
    },
    [message],
  );
}
